import React from 'react';

import './AddCollector.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner} from '@fortawesome/free-solid-svg-icons';



class AddCollector extends React.Component{
constructor(props){
  super(props);
  this.state = {
    collectorNo:'',
    collectorName:'',
    collectorSurname:'',
    collectorGender:'',
    collectorRef:'',
    collectorRel:'',
    collectorCell:'',
    collectorEmail:'',
  }
}

// changeCollectorPin = (event) =>{
//
// var pin = event.target.value
//
// this.setState({collectorPin:pin});
//
// }



changeCollectorEmail = (event) =>{

this.setState({collectorEmail:event.target.value});

}




changeCollectorCell = (event) =>{

var number = event.target.value;

number = number.charAt(0) === '0' ? '+27'+number.substr(1): (number.charAt(0) === '+' ? number  : '+27' + number);

this.setState({collectorCell:number});

}



changeCollectorNo = (event) =>{

var collectno = event.target.value;
  if(collectno.length === 13){
    document.getElementById("overlay").style.display = "block";
  //Check duplicates
  fetch('https://schoolportal.appsdesign.co.za/colno/'+ collectno +'/'+ localStorage.getItem('schoolToken'))
  .then((response) => response.json())
  .then((responseJson) => {
  if(responseJson[0] !== undefined){
    //if no match then:

    //else :
  document.getElementById("overlay").style.display = "none";
    alert('The collector no is unavailable, please try another.')

  }
  else{
    document.getElementById("overlay").style.display = "none";
  alert('collector no ok');


  this.setState({collectorNo:collectno});
  }


  })
  .catch((error) =>{
    console.error(error);
  });


  //if no match then:
  //this.setState({collectorPin:event.target.value});


  }







}

changeCollectorName = (event) =>{

this.setState({collectorName:event.target.value});

}

changeCollectorSurname = (event) =>{

this.setState({collectorSurname:event.target.value});

}

changeCollectorGender = (event) =>{

this.setState({collectorGender:event.target.value});

}

changeCollectorRel = (event) =>{

this.setState({collectorRel:event.target.value});

}

changeCollectorRef = (event) =>{

this.setState({collectorRef:event.target.value});

}



addCollector = () =>{

if(this.state.collectorNo === ''){

  alert('please add a collector no');
}
else if(this.state.collectorName === ''){

  alert('please add a collector name');
}

else if(this.state.collectorSurname === ''){

  alert('please add a collector surname');
}

else if(this.state.collectorGender === ''){

  alert('please select collector gender');
}



else if(this.state.collectorNo.length !== 13){

  alert('Collector no must be 6 digits and/or characters in length');
}


else{
alert(`Adding collector \n\r
       Collector no: ${this.state.collectorNo} \n\r
       Collector name: ${this.state.collectorName} \n\r
       Collector surname: ${this.state.collectorSurname} \n\r
       Collector gender: ${this.state.collectorGender} \n\r
       Collector Reference: ${this.state.collectorRef} \n\r
       Collector Mobile No: ${this.state.collectorCell} \n\r
       Collector Email: ${this.state.collectorEmail} \n\r`)


       fetch('https://schoolportal.appsdesign.co.za/add_collector', {
           method: 'post',
           headers: {'Content-Type' : 'application/json'},
           body: JSON.stringify({
               school:localStorage.getItem('schoolToken'),
               name: this.state.collectorName,
               surname: this.state.collectorSurname,
               gender: this.state.collectorGender,
               refrence: this.state.collectorRef,
               cell: this.state.collectorCell,
               email: this.state.collectorEmail,
               text: this.state.collectorNo,
               code: this.state.collectorNo,
               deleted: false,
               old_cousin: "",
               fc_color: "",
               first_job: "",
               birth_town: ""
         })
       })
         .then(response =>{

           this.setState({
             collectorNo:'',
             collectorName:'',
             collectorSurname:'',
             collectorGender:'',
             collectorRef:'',
             collectorRel:'',
             collectorCell:'',
             collectorEmail:'',
             collectorPin:'',
           }, function(){

             var elements = document.getElementsByTagName("input");
             for (var ii=0; ii < elements.length; ii++) {
               if (elements[ii].type === "text") {
                 elements[ii].value = "";
               }
             }


             alert('Collector has been added')

           })


})
}
}
render(){

return(
  this.props.isAuthed ?




  <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,  backgroundColor:'white'}}>


    <div id="overlay">
      <div id="text">
      Validating, please wait ....

<FontAwesomeIcon icon={faSpinner} size="3x" pulse/>

      </div>
    </div>

<div>
  <h1>Enter collector details</h1>
  <label htmlFor="collectorNo" style={{marginRight:45}}>
  Collector No</label>
<input
type="text"
placeholder="Collector No"
id="collectorNo"
className="pa2 ma2"
onKeyUp={this.changeCollectorNo}
/>
  <br/>

  <label htmlFor="collectorName" style={{marginRight:20}}>
  Collector Name </label>
<input
type="text"
placeholder="Collector Name"
id="collectorName"
className="pa2 ma2"
onKeyUp={this.changeCollectorName}
/>
<br/>

  <label htmlFor="collectorSurname">
  Collector Surname</label>
<input
type="text"
placeholder="Collector Surname"
id="collectorSurname"
className="pa2 ma2"
onKeyUp={this.changeCollectorSurname}
/>
  <br/>


    <label htmlFor="collectorGender">
    Collector Gender</label>
  <select
  id="collectorGender"
  className="pa2 ma2"
  onChange={this.changeCollectorGender}
    >
  <option value="">Please select</option>
    <option value="male">Male</option>
      <option value="female">Female</option>
        <option value="other">Other</option>
        </select>
    <br/>

    <label htmlFor="collectorCell">
    Collector Mobile No</label>
  <input
  type="text"
  placeholder="Collector Mobile No"
  id="collectorCell"
  className="pa2 ma2"
  onKeyUp={this.changeCollectorCell}
  />
    <br/>


    <label htmlFor="collectorEmail" style={{marginRight:35}}>
    Collector Email</label>
  <input
  type="text"
  placeholder="Collector Email"
  id="collectorEmail"
  className="pa2 ma2"
  onKeyUp={this.changeCollectorEmail}
  />
    <br/>




























{
    //  <label htmlFor="collectorRel">
  //    Collector Relationship
//    <input
//    type="text"
//    placeholder="Collector Relationship"
//    id="collectorRel"
  //  className="pa2 ma2"
//    onKeyUp={this.changeCollectorRel}
//    />
//      </label><br/>


    //   <label htmlFor="collectorRef">
    //   Collector Reference
    // <input
    // type="text"
    // placeholder="Collector Reference"
    // id="collectorRef"
    // className="pa2 ma2"
    // onKeyUp={this.changeCollectorRef}
    // />
    //   </label><br/>

}
    <button  className="ma3 br3 pa3 bg-blue br-blue" onClick={this.addCollector}>Add Collector</button>
</div>
  </div>
  :

  <h1> your out, sorry not authenticated </h1>

)

}

}

export default AddCollector;



// WEBPACK FOOTER //
// ./src/components/AddCollector/AddCollector.js